var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPushNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2932 7.10773C25.8332 5.61398 24.3857 4.16648 22.8919 4.70773L4.63569 11.3102C3.13694 11.8527 2.95569 13.8977 4.33444 14.6965L10.1619 18.0702L15.3657 12.8665C15.6014 12.6388 15.9172 12.5128 16.2449 12.5156C16.5727 12.5185 16.8862 12.65 17.118 12.8817C17.3497 13.1135 17.4812 13.427 17.484 13.7547C17.4869 14.0825 17.3609 14.3982 17.1332 14.634L11.9294 19.8377L15.3044 25.6652C16.1019 27.044 18.1469 26.8615 18.6894 25.364L25.2932 7.10773Z",
    fill: "#066D0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPushNotification);
export default __webpack_public_path__ + "static/media/icon-push-notification.6fecd6290da8c03b863eb3866eb9f686.svg";
export { ForwardRef as ReactComponent };